import {
    DATA_LOADING, SET_START_MONITORING, SET_YH_ADDRESS, SET_YH_PORT,
} from "./constants/action-types";

export const abbrNum = (number, decPlaces = 2) => {
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);

    // Enumerate number abbreviations
    const abbrev = [" K", " M", " B", " T"];

    // Go through the array backwards, so we do the largest first
    for (let i = abbrev.length - 1; i >= 0; i--) {
        // Convert array index to "1000", "1000000", etc
        const size = Math.pow(10, (i + 1) * 3);

        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round((number * decPlaces) / size) / decPlaces;

            // Handle special case where we round up to the next abbreviation
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }

            // Add the letter for the abbreviation
            number += abbrev[i];

            // We are done... stop
            break;
        }
    }

    return number;
};

export const setYhAddress = (yhAddress) => (dispatch) => {
    dispatch({
        type: SET_YH_ADDRESS,
        payload: yhAddress,
    });
};

export const setYhPort = (yhPort) => (dispatch) => {
    dispatch({
        type: SET_YH_PORT,
        payload: yhPort,
    });
};


export const startMonitoring = () => (dispatch, getState) => {
    const prevState = getState().yh.startMonitoring;

    dispatch({
        type: SET_START_MONITORING,
        payload: !prevState,
    });
};

export const loadingOn = () => (dispatch) => {
    dispatch({
        type: DATA_LOADING,
        payload: true,
    });
};

export const loadingOff = () => (dispatch) => {
    dispatch({
        type: DATA_LOADING,
        payload: false,
    });
};